// extracted by mini-css-extract-plugin
module.exports = {"chartAxisTop":"style__chartAxisTop__Gcr3p","tick":"style__tick__cKj1L","topTines":"style__topTines__nc1yB","chartAxisBottom":"style__chartAxisBottom__yx6u1"};